import { checkIfPaymentInAdvanceAmountIsValid } from 'utils';

import { Store } from '../../types';

export const carContractValidator = ({
	chosenLeaseCar: {
		duration,
		kilometrage,
		pricePointId,
		upgrade,
		color,
		paymentInAdvanceChoice,
		paymentInAdvanceAmount,
		totalPrice,
	},
}: Store): boolean => {
	const isPaymentInAdvanceValid = paymentInAdvanceChoice
		? checkIfPaymentInAdvanceAmountIsValid(paymentInAdvanceAmount, totalPrice, Number(duration))
		: true;
	return !(
		!duration ||
		!kilometrage ||
		!pricePointId ||
		!upgrade ||
		!color ||
		!isPaymentInAdvanceValid
	);
};
